<template>
  <div class="order-summary flux-xs-sm">
    <expiry-date></expiry-date>
    <b-card tag="article" class="container border-md-none mb-7 pt-8 card-shadow pb-0" no-body>
      <div class="row">
        <template v-if="isCutoverWeekend">
          <div class="col-12 px-0 mx-auto order-summary-card-wrapper sticky-container">
            <div class="px-4">
              <section class="order-summary-list mx-auto">
                <div class="text-center">
                  <h2 class="mb-3 text-primary font-weight-bold">
                    {{ content.cutover_weekend_title }}
                  </h2>
                  <p class="mb-7" v-dynamic-content:cutover_weekend_subtitle></p>
                </div>
              </section>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="col-12 px-0 mx-auto order-summary-card-wrapper sticky-container">
            <div class="px-4">
              <section class="order-summary-list mx-auto">
                <div class="text-center">
                  <h2 class="mb-3 text-primary font-weight-bold">
                    {{ content.summary_order_title }}
                  </h2>
                  <p class="mb-7" v-dynamic-content:summary_order_subtitle></p>
                </div>

                <b-alert
                  v-show="paymentFailed"
                  show
                  variant="danger"
                  v-dynamic-content:summary_error_paymentfailed
                />

                <b-alert
                  v-if="paymentRedirect"
                  show
                  variant="danger"
                  class="d-flex align-items-center"
                >
                  <div class="loader-spinner ml-0 ml-md-8 mr-8" />
                  <h5 class="after-payment-wrapper m-0" v-dynamic-content:checking_payment_status />
                </b-alert>
                <b-alert
                  v-else-if="paymentPending"
                  show
                  variant="danger"
                  v-dynamic-content:summary_message_payment_open
                />

                <order-summary-card
                  :quote="quote"
                  :productsServices="getProductsServices()"
                  :showProductsServices="showProductsServices()"
                ></order-summary-card>
              </section>
              <b-form
                @submit.prevent="onSubmit"
                novalidate
                v-if="!isPreviouslyChosenQuoteInRedesignQuote"
              >
                <p class="font-size-sm mb-7 mt-7" v-dynamic-content:summary_disclaimer></p>
                <div class="b-container mb-7 justify-content-center px-5">
                  <div
                    class="col-md-6 mx-auto mt-7 mb-4 px-0 px-md-4 d-flex justify-content-md-center"
                  >
                    <b-form-group
                      :state="$v.$dirty ? !$v.$invalid : null"
                      style="position: relative"
                    >
                      <b-form-checkbox
                        class="font-size-sm mb-4"
                        v-if="showConfirmToLiveOnAddress"
                        v-model="confirmAddress"
                        :state="$v.confirmAddress.$dirty ? !$v.confirmAddress.$invalid : null"
                        :value="true"
                        :unchecked-value="false"
                        :disabled="loading"
                      >
                        <span
                          class="pt-xl-1"
                          v-dynamic-content:summary_tickbox_confirm_to_live_on_address="[address]"
                        ></span>
                      </b-form-checkbox>

                      <p class="font-size-sm"
                        v-if="termsAndConditions.length > 0"
                        v-dynamic-content:terms_conditions_tickbox
                      ></p>
                      <b-form-checkbox-group
                        class="font-size-sm mt-4"
                        v-model="agreeTermsAndConditions"
                        stacked
                      >
                        <div class="mb-3" v-for="([name, link], i) in termsAndConditions" :key="i">
                          <b-form-checkbox v-bind:value="i" :disabled="loading">
                            <span v-dynamic-content="{ rawText: name, substitutions: [link] }"></span>
                          </b-form-checkbox>
                        </div>
                      </b-form-checkbox-group>

                      <b-form-invalid-feedback
                        class="font-size-sm"
                        :state="checkboxesHaveBeenTouched"
                      >
                        <div v-if="$v.agreeTermsAndConditions.$invalid">
                          {{ content.summary_error_acceptconditions }}
                        </div>
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </div>
                </div>
                <div
                  class="d-flex align-items-center justify-content-center"
                  v-if="content.payment_conditions"
                >
                  <p class="font-size-sm mb-7" v-dynamic-content:payment_conditions></p>
                </div>
              </b-form>
              <div
                class="
                  col-12 col-md-10 col-lg-6
                  px-7
                  mx-7
                  my-6
                  d-flex
                  mx-auto
                  flex-wrap
                  justify-content-center
                "
                v-if="!skipDownpayment"
              >
                <img
                  v-for="method in paymentMethods"
                  :key="method"
                  class="payment-img mx-1 mx-lg-3 mb-5 mb-md-0"
                  :src="getPaymentImage(method)"
                />
              </div>
            </div>

            <sticky-cta :withSteps="$mq === 'xl' && !isGeneric">
              <b-button class="btn-block mb-1" variant="primary" @click="submit" v-if="!loading">
                {{ orderConfirmationButtonText }}
              </b-button>
              <div class="loader-spinner" v-if="loading"></div>
            </sticky-cta>
          </div>
        </template>
      </div>
      <div class="d-flex justify-content-between flex-wrap align-items-end">
        <backto-top-button v-if="$mq === 'md' || $mq === 'sm' || $mq === 'xs'"></backto-top-button>
      </div>
    </b-card>
    <div class="d-flex justify-content-start">
      <router-link
        :to="{ name: 'ContentProposal' }"
        class="d-flex justify-content-center align-items-center back-link font-weight-bold"
        v-dynamic-content:summary_goback
      ></router-link>
    </div>
    <content-low></content-low>
  </div>
</template>

<script>
import BacktoTopButton from '@/components/main/scroll/BacktoTopButton'
import OrderSummaryCard from './OrderSummaryCard'
import ContentLow from '../parts/ContentLow'
import StickyCta from '@/components/parts/StickyCta'
import config from 'config'
import ExpiryDate from '@/components/parts/ExpiryDate.vue'
import { sameAs } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'

export default {
  name: 'OrderSummary',
  props: ['id'],
  components: {
    ContentLow,
    OrderSummaryCard,
    BacktoTopButton,
    ExpiryDate,
    StickyCta,
  },
  validations() {
    return {
      agreeTermsAndConditions: {
        length: (model) => model.length === this.termsAndConditions.length,
      },
      confirmAddress: { sameAs: sameAs(() => (this.showConfirmToLiveOnAddress ? true : null)) },
    }
  },
  data() {
    return {
      agreeTermsAndConditions: [],
      confirmAddress: null,
      payment: null,
      paymentMethods: config['payment.methods'][this.$store.getters.country],
      loading: false,
    }
  },
  computed: {
    isCutoverWeekend() {
      return false
    },
    ...mapGetters([
      'isNetherlands',
      'isBelgium',
      'isGeneric',
      'isIChoosr',
      'isOpenRedesign',
      'isCompletedRedesign',
      'fullName',
    ]),
    quote() {
      return this.quotes.find((x) => x.id === this.id)
    },
    paymentFailed() {
      return this.$store.getters.iquote.paymentStatus === 'FAILED'
    },
    paymentPending() {
      return this.$store.getters.iquote.paymentStatus === 'OPEN'
    },
    paymentRedirect() {
      return this.$store.getters.externalQuery.paymentRedirect
    },
    termsAndConditions() {
      const ageOfProperty = this.$store.getters.iquote.ageOfProperty
      const { replaceDynamicContent } = this.$options.filters

      const termsAndConditions = []

      if (this.quote.termsAndConditions.length > 0) {
        this.quote.termsAndConditions.forEach(({ type, pdfUrl }) => {
          if (type === 'terms_and_conditions') {
            termsAndConditions.push([this.content.conditions_general, pdfUrl])
          } else if (type === 'sunsure') {
            termsAndConditions.push([this.content.conditions_sunsure, pdfUrl])
          } else if (type === 'inverter_only') {
            termsAndConditions.push([this.content.conditions_inverter, pdfUrl])
          } else if (type === 'battery_only') {
            termsAndConditions.push([this.content.conditions_battery, pdfUrl])
          }
        })
      }

      if (this.isBelgium && ageOfProperty === 'building_older_than_10_years') {
        termsAndConditions.push([
          replaceDynamicContent(this.content.summary_tickbox_tax_building_older_than_10_years, [
            this.valueAddedTaxTariffPercentage,
          ]),
          null,
        ])
      } else if (this.isBelgium && ageOfProperty === 'building_younger_than_10_years') {
        termsAndConditions.push([
          replaceDynamicContent(this.content.summary_tickbox_tax_building_younger_than_10_years, [
            this.valueAddedTaxTariffPercentage,
          ]),
          null,
        ])
      }

      return termsAndConditions
    },
    skipDownpayment() {
      return (
        this.isIChoosr ||
        this.iquote.redesignState === 'redesign_not_approved' ||
        this.quote.detailOverview.downPaymentAmount === 0
      )
    },
    address() {
      return this.$store.getters.streetAndHouseNumber
    },
    orderConfirmationButtonText() {
      if (this.isOpenRedesign && this.isPreviouslyChosenQuoteInRedesignQuote)
        return this.content.redesign_card_current_button
      else if (this.isOpenRedesign) return this.content.redesign_card_new_button
      else if (this.skipDownpayment) return this.content.order_summary_confirm_order
      else return this.content.summary_cta_pay
    },
    showConfirmToLiveOnAddress() {
      return this.isIChoosr
    },
    isPreviouslyChosenQuoteInRedesignQuote() {
      return this.id === this.$store.getters.iquote.chosenQuoteId
    },
    orderConfirmed() {
      return this.iquote.orderPlaced
    },
    isActiveOrCompletedRedesign() {
      return this.isOpenRedesign || this.isCompletedRedesign
    },
    valueAddedTaxTariffPercentage() {
      return this.quote.detailOverview.valueAddedTaxTariffPercentage
    },
    checkboxesHaveBeenTouched() {
      // The b-form-invalid-feedback wants a state=false in order to show, hence how we name this
      // https://bootstrap-vue.org/docs/components/form/#comp-ref-b-form-invalid-feedback
      return !this.$v.agreeTermsAndConditions.$dirty
    },
  },
  methods: {
    getPaymentImage(name) {
      try {
        return require(`@/assets/icons/paymentmethods/${name}.svg`)
      } catch (e) {
        return false
      }
    },
    async checkPaymentAndUserStatus(wait = 0) {
      await this.$store.dispatch('getIquote')
      if (this.orderIsCompleted()) {
        this.$router.push({ name: 'Order' })
      } else if (this.paymentIsFailed) {
        this.$store.commit('RESET_EXTERNAL_QUERY_PAYMENT_REDIRECT', false)
      } else if (wait < 7000) {
        setTimeout(() => this.checkPaymentAndUserStatus(wait + 1000), wait)
      } else {
        // if cognito account creations has failed we still want to send the customer to the last page
        if (this.isActiveOrCompletedRedesign ? this.isCompletedRedesign : this.orderConfirmed)
          this.$router.push({ name: 'Order' })
        this.loading = false
        this.$store.commit('RESET_EXTERNAL_QUERY_PAYMENT_REDIRECT', false)
      }
    },
    orderIsCompleted() {
      if (this.isActiveOrCompletedRedesign) return this.isCompletedRedesign
      else return this.orderConfirmed
    },
    async submit() {
      this.$v.$touch()
      // ignore submit when validation fails, but ignore
      // validation when the previous won quote is rechosen in a redesign quote
      if (this.$v.$invalid && !this.isPreviouslyChosenQuoteInRedesignQuote) return

      // get external preview mode from store
      const externalQuery = this.$store.getters.externalQuery
      if (externalQuery && externalQuery.preview) {
        alert('You cannot pay/confirm an order in preview mode.')
        return null
      }

      const chosenAddons = this.$store.getters.productsServices.map((addon) => ({
        defaultCode: addon.productId,
      }))
      this.loading = true

      if (this.skipDownpayment) {
        // TODO This will not inform the user that something went wrong.
        await this.$store.dispatch('confirmOrder', {
          chosenQuoteId: this.quote.id,
          chosenAddons,
        })

        this.checkPaymentAndUserStatus()
      } else {
        try {
          const res = await this.$store.dispatch('postPayment', {
            chosenQuoteId: this.quote.id,
            chosenAddons,
          })
          this.loading = false
          if (res.data.errors) throw res.data.errors
          location.replace(res.data.data.createPaymentTransaction.apiUrl)
        } catch (err) {
          // TODO This will not inform the user that something went wrong. Perhaps related to
          //  the paymentStatus field after the route has been changed?
          this.$router.push(`/iquote/${this.iquote.id}`)
          throw err
        }
      }
    },
    getProductsServices() {
      return this.$store.getters.productsServices.map(
        ({ translationKey, priceInclVAT, productId }) => ({
          text: { title: this.content[`${translationKey}_title`] },
          priceInclVAT: priceInclVAT,
          productId,
        })
      )
    },
    showProductsServices() {
      return this.quote.addons ? this.quote.addons.length : 0
    },
  },
  mounted() {
    if (this.paymentRedirect) {
      this.checkPaymentAndUserStatus()
    }

    if (this.$store.getters.iquote.orderPlaced && !this.isOpenRedesign) {
      this.$router.push(`/iquote/${this.iquote.id}/order`)
    }

    window.dataLayer.push({
      event: 'page_load',
      element: 'system order',
      quote_type: this.$store.getters.quoteType,
    })

    this.$store.dispatch('putActivity', {
      activity: 'VIEW_SUMMARY',
      quoteId: this.quote.id,
    })
    this.$store.commit('SET_SCROLL_POSITION', 0)
  },
}
</script>
